import React from "react";

import { CategoryBarChart } from "../charts/CategoryBarChart";
import { ChartLayout, axisLabel, formatterFromTickformat, layoutHeight, layoutWidth } from "../charts/chartTheme";

interface IUseOfProceedsProps {
    useOfProceeds: any;
    totalExposure: number;
    layout?: ChartLayout;
    style?: React.CSSProperties | undefined;
}

export const UseOfProceeds = ({ useOfProceeds, totalExposure, layout, style }: IUseOfProceedsProps): React.ReactElement => {
    const labels = Object.keys(useOfProceeds ?? {});
    const rows = labels.map((label) => ({
        category: label,
        series: "Use of proceeds",
        value: totalExposure ? Number(useOfProceeds[label]) / totalExposure : 0
    }));

    return (
        <CategoryBarChart
            rows={rows}
            orientation="horizontal"
            showLegend={layout?.showlegend ?? false}
            valueFormat={formatterFromTickformat(layout?.xaxis?.tickformat || ".0%")}
            ariaLabel="Use of proceeds"
            height={layoutHeight(layout, 350)}
            width={layoutWidth(layout) ?? 600}
            style={style}
        />
    );
};
